module.exports = __webpack_public_path__ + "static/media/9.a1d597e5.jpg";